import axios from "axios"

const rei = axios.create({
  baseURL: process.env.VUE_APP_SOFIA_REI_API_URL || `http://${window.location.hostname}:8081/api`,
  timeout: Infinity,
  headers: {}
})

const auth = axios.create({
  baseURL: process.env.VUE_APP_SOFIA_REI_AUTH_URL || `http://${window.location.hostname}:8085/api`,
  // baseURL: `http://${window.location.hostname}:8085/api`,
  timeout: Infinity,
  headers: {}
})

const ws = axios.create({
  baseURL: process.env.VUE_APP_WS_URL || `ws://${window.location.hostname}:8081`,
  timeout: Infinity,
  headers: {}
})

// selosApi aponta para o nosso REI server (mesma baseURL/auth do rei) enquanto a
// nova API de envio de selos (seloworker) não sobe em produção.
// Quando a API nova for liberada, voltar para o axios.create original abaixo.
const selosApi = rei

// const selosApi = axios.create({
//   baseURL: process.env.VUE_APP_API_ENVIO_SELOS_URL,
//   timeout: 10000,
//   headers: {
//     Authorization: `Bearer ${process.env.VUE_APP_API_ENVIO_SELOS_TOKEN}`
//   }
// })

export { axios, rei, auth, ws, selosApi }
